import React from 'react';
import {Panel, PanelList, Tab, TabList, Tabs} from '@react-tabtab-next/tabtab';
import tabStyle from './style/tab'
import {MGuide} from './guide';
import {MHistory} from './history';
import request from '../utils/request';
import {LanguageContext} from '../utils/i18nProvider';
import {LanguageSwitcher} from '../components/languageswitcher';

class MHome extends React.PureComponent{
  static contextType = LanguageContext;

  state = {
    machine: {},
    potChangeRequests: [],
    activeIndex: 0,
    qrExpired: false,
  };
  
  async componentDidMount() {
    const params = window.location.pathname.substr(1).split('/');
    if (params.length >= 4) {
      localStorage.setItem('vidNumber', params[1]);
      localStorage.setItem('cookCount', params[2]);
      localStorage.setItem('accessToken', params[3]);
    }
    this.loadData();
  }
  
  async loadData() {
    const response1 = await request(`/as/hg/open/machine/${localStorage.getItem('vidNumber')}?cookCount=${localStorage.getItem('cookCount')}`);
    if (response1.constructor.name !== 'Error') {
      this.setState({
        machine: response1,
        qrExpired: false,
      });
    } else if (response1.message === '页面已过期，请重新扫描') {
      this.setState({
        machine: { machineId: '-1' },
        qrExpired: true,
      });
      return;
    } else {
      this.setState({
        machine: {
          machineId: '-1',
        },
        qrExpired: false,
      });
      response1.machineId = '-1';
    }
    const response2 = await request(`/as/hg/open/potChangeRequests/findAll?vidNumber=${localStorage.getItem('vidNumber')}&bizMachineId=${response1.machineId}`);
    if (response2.constructor.name !== 'Error') {
      this.setState({
        potChangeRequests: response2._embedded.bizPotChangeRequests,
      });
    } else {
      this.setState({
        potChangeRequests: [],
      })
    }
  }
  
  onRequestSubmitted = () => {
    this.loadData().then(() => {
      this.setState({
        activeIndex: 1
      })
    });
  };
  
  onRequestModified = () => {
    this.loadData();
  };
  
  onDeleteSubmitted = () => {
    this.loadData();
  };

  // 左右滑动切换页签（换锅申请 / 换锅记录）
  handleTouchStart = (e) => {
    const touch = e.touches[0];
    this.touchStartX = touch.clientX;
    this.touchStartY = touch.clientY;
    const el = e.target;
    // 在视频、输入框、文本域上滑动不触发切页，避免与进度条/文本编辑冲突
    this.swipeDisabled = !!(el && el.closest && el.closest('video, input, textarea'));
  };

  handleTouchEnd = (e) => {
    if (this.swipeDisabled) {
      this.swipeDisabled = false;
      return;
    }
    const touch = e.changedTouches[0];
    const dx = touch.clientX - this.touchStartX;
    const dy = touch.clientY - this.touchStartY;
    // 水平位移超过阈值且明显大于垂直位移，才判定为左右滑动
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
      const { activeIndex } = this.state;
      if (dx < 0 && activeIndex < 1) {
        this.setState({ activeIndex: activeIndex + 1 });
      } else if (dx > 0 && activeIndex > 0) {
        this.setState({ activeIndex: activeIndex - 1 });
      }
    }
  };

  render() {
    const { machine, potChangeRequests, activeIndex, qrExpired } = this.state;
    const { t } = this.context;
    return (
      <React.Fragment>
        <div
          onTouchStart={this.handleTouchStart}
          onTouchEnd={this.handleTouchEnd}
        >
          <Tabs
            customStyle={tabStyle}
            showArrowButton={false}
            activeIndex={activeIndex}
            onTabChange={index => {
              this.setState({
                activeIndex: index
              })
            }}
          >
            <TabList>
              <Tab>{t('换锅申请')}</Tab>
              <Tab>{t('换锅记录')}</Tab>
            </TabList>
            <PanelList>
              <Panel>
                {machine.machineId &&
                  <MGuide
                    machine={machine}
                    potChangeRequests={potChangeRequests}
                    qrExpired={qrExpired}
                    onRequestSubmitted={this.onRequestSubmitted}
                    onRequestModified={this.onRequestModified}
                  />
                }
              </Panel>
              <Panel>
                {machine.machineId &&
                  <MHistory
                    machine={machine}
                    potChangeRequests={potChangeRequests}
                    onDeleteSubmitted={this.onDeleteSubmitted}
                  />
                }
              </Panel>
            </PanelList>
          </Tabs>
        </div>
        <LanguageSwitcher />
      </React.Fragment>
    );
  }
}

export {MHome};
